import project01 from "./../img/projects/01.jpg";
import project01Big from "./../img/projects/01-big.jpg";

import project02 from "./../img/projects/02.jpg";
import project02Big from "./../img/projects/02-big.jpg";

import project03 from "./../img/projects/03.jpg";
import project03Big from "./../img/projects/03-big.jpg";

import project04 from "./../img/projects/04.jpg";
import project04Big from "./../img/projects/04-big.jpg";

const projects = [
	{
		title: 'Burgers restaurant site',
		skills: 'Angular, HTML, CSS',
		img: project01,
		imgBig: project01Big,
		gitHubLink: 'https://github.com/lexkh/burgers',
	},
	{
		title: 'Farmgame site',
		img: project02,
		imgBig: project02Big,
		skills: 'HTML, CSS',
		gitHubLink: 'https://github.com/xelvhk/farmgame',
	},
	{
		title: 'Fashion store',
		img: project03,
		imgBig: project03Big,
		skills: 'React,HTML,CSS',
		gitHubLink: 'https://github.com/xelvhk/fashion_store_with_React',
	},
	{
		title: 'Teacher portfolio',
		img: project04,
		imgBig: project04Big,
		skills: 'Tilda',
		gitHubLink: 'https://annafort.ru/',
	},
];

export {projects}